/**
 * Le code promo saisi à l'inscription, transporté jusqu'à l'écran de
 * paiement.
 *
 * POURQUOI PAS L'URL. `/plans?tier=pro&cycle=annual` est déjà l'endroit
 * où voyagent la formule et le cycle ; y ajouter `&promo=XXX` aurait été
 * la ligne la plus courte. Mais une URL se partage, se colle dans un
 * message, part dans le `Referer` vers les tiers, et finit dans les
 * rapports d'analytics. Un code promo est une valeur à usage limité :
 * le laisser fuiter par la barre d'adresse, c'est le donner.
 *
 * POURQUOI PAS localStorage. Parce que ce code n'a de sens que dans le
 * trajet inscription → paiement, qui se joue dans un onglet et dans les
 * secondes qui suivent. `sessionStorage` meurt avec l'onglet ; un code
 * oublié dans `localStorage` ressortirait dans trois semaines sur un
 * achat sans rapport.
 *
 * CE QU'ON STOCKE N'ACCORDE RIEN. C'est du TEXTE, revalidé par le
 * serveur au montage du champ de paiement puis une troisième fois à la
 * création de la session Stripe. Quelqu'un qui écrirait la clé à la main
 * dans la console n'obtiendrait qu'un « Code invalide » de plus.
 */
const KEY = 'archer_signup_promo';

/** Mémorise le code validé à l'inscription. `null`/'' efface. */
export function rememberSignupPromo(code) {
  try {
    const value = String(code || '').trim();
    if (!value) window.sessionStorage.removeItem(KEY);
    else window.sessionStorage.setItem(KEY, value);
  } catch (_) {
    // Navigation privée, quota, stockage désactivé : le code sera
    // simplement redemandé à l'écran de paiement. Jamais bloquant.
  }
}

/** Le code mémorisé, ou ''. Ne consomme pas. */
export function peekSignupPromo() {
  try {
    return window.sessionStorage.getItem(KEY) || '';
  } catch (_) {
    return '';
  }
}

/**
 * Le code mémorisé, puis oubli immédiat.
 *
 * L'écran de paiement le lit UNE fois, au montage. Sans cet effacement,
 * un client qui annule, va voir une autre offre et revient se verrait
 * réappliquer un code qu'il croyait avoir abandonné.
 */
export function takeSignupPromo() {
  const value = peekSignupPromo();
  try {
    window.sessionStorage.removeItem(KEY);
  } catch (_) { /* cf. ci-dessus */ }
  return value;
}

export default { rememberSignupPromo, peekSignupPromo, takeSignupPromo };
